export const getTripType = (searchQuery: Record<any, any>) => {
  return searchQuery?.flight_1_origin
    ? "MultiCity"
    : searchQuery.returnDate && searchQuery.returnDate.length > 0
    ? "RoundTrip"
    : "OneWay";
};
